import { Field } from '@ztechapps/webui.form'
import { PhoneNumberInput } from '@ztechapps/webui.input'
import React from 'react'

export const RegFormWithPhone = () => {
  return <Field name="phone" label="Phone number" component={PhoneNumberInput} help="A way for us to contact you." />
}
